import { FC } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

import { useSSMHistoryData } from './useSSMHistoryData'
import ExpenseTrendChart from './charts/ExpenseTrendChart'
import NistBreakdownChart from './charts/NistBreakdownChart'
import AssetTypesBreakdownChart from './charts/AssetTypesBreakdownChart'
import { HistoricalOverviewContainer, BreakdownRow, LoadingContainer } from './ssmHistoricalOverview.styles'

const SSMHistoricalOverview: FC = () => {
  const { loading, error, expenseTrendData, sortedYears, nistPillars, assetTypes } = useSSMHistoryData()

  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress color="inherit" size={40} />
      </LoadingContainer>
    )
  }

  if (error) {
    return (
      <LoadingContainer>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ color: '#d0c3cc', fontSize: '16px', fontFamily: 'Quicksand, sans-serif' }}>
            {error}
          </Typography>
        </Box>
      </LoadingContainer>
    )
  }

  return (
    <HistoricalOverviewContainer>
      <ExpenseTrendChart data={expenseTrendData} loading={loading} />
      <BreakdownRow>
        <NistBreakdownChart years={sortedYears} nistPillars={nistPillars} loading={loading} />
        <AssetTypesBreakdownChart years={sortedYears} assetTypes={assetTypes} loading={loading} />
      </BreakdownRow>
    </HistoricalOverviewContainer>
  )
}

export default SSMHistoricalOverview
